import React, { useEffect, useState } from "react";

const Count = () => {
  const [count, setCount] = useState(3);
  const [animate, setAnimate] = useState(true);
  const [fontSize, setFontSize] = useState("120px");
  const [intentUrl, setIntentUrl] = useState("");

  useEffect(() => {
    const query = window.location.search; // Contains ?code=...

    // Direct custom scheme callback (works for both Android & iOS)
    const url = `duepay://callback${query}`;
    setIntentUrl(url);

    // Auto-trigger navigation
    window.location.href = url;
  }, []);

  // Responsive font size
  useEffect(() => {
    const updateSize = () => {
      if (window.innerWidth < 480) {
        setFontSize("60px");
      } else if (window.innerWidth < 768) {
        setFontSize("80px");
      } else {
        setFontSize("120px");
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // Countdown logic
  useEffect(() => {
    if (count === 0) return;

    const timer = setTimeout(() => {
      setAnimate(false);
      setTimeout(() => {
        setCount((prev) => prev - 1);
        setAnimate(true);
      }, 200);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff",
        padding: "20px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <h2 style={{ color: "#102238", marginBottom: "10px" }}>
        Authentication Successful!
      </h2>
      <p style={{ color: "#666", marginBottom: "20px" }}>
        Returning to DuePay app...
      </p>

      <div
        style={{
          fontSize: fontSize,
          fontWeight: "bold",
          color: "#102238",
          transform: animate ? "scale(1.2)" : "scale(0.8)",
          opacity: animate ? 1 : 0.3,
          transition: "all 0.4s ease",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        {count > 0 ? count : "Go!"}
      </div>

      {intentUrl && (
        <a
          href={intentUrl}
          style={{
            padding: "14px 28px",
            backgroundColor: "#4F46E5",
            color: "white",
            textDecoration: "none",
            borderRadius: "8px",
            fontWeight: "600",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "10px",
          }}
        >
          Open DuePay App
        </a>
      )}
    </div>
  );
};

export default Count;